import lodashCloneDeep from "lodash/cloneDeep";

import { httpGet } from "@/services/api.service";
import { ENDPOINT_EXTERNAL_LAYERS_CONFIG } from "@/common/constants/api";
import { isFeatureUnlocked } from "@/common/featureLock.js";
import { addTileData, removeTileData } from "@/common/maps/features";

export { _addTilesToMap as addTilesToMap };
export { _getExternalLayersConfig as getExternalLayersConfig };

let layersConfig = null;

const _addTilesToMap = ({
  map = undefined,
  layerId = undefined,
  layerSource = undefined,
  layerSourceType = "vector",
  layerSourceLayer = undefined,
  layerType = "fill",
  layerMetadata = undefined,
  tileUrl = undefined,
  mapClickEvent = undefined,
  layerOptions = {
    type: "circle",
    paint: {
      "circle-radius": 7,
      "circle-color": "orange",
      "circle-stroke-width": 0,
    },
  },
} = {}) => {
  if (
    !map ||
    !layerId ||
    !layerSource ||
    !layerSourceType ||
    !layerSourceLayer ||
    !tileUrl
  ) {
    console.error("Unable to add map controls tiles data, missing information");
  }

  layerOptions["id"] = layerId;
  layerOptions["type"] =
    layerSourceType === "raster" ? layerSourceType : layerType;
  layerOptions["source"] = layerSource;
  layerOptions["source-layer"] = layerSourceLayer;
  layerOptions["metadata"] = layerMetadata;

  let source = {
    type: layerSourceType,
    tiles: [tileUrl],
    tolerance: 0,
  };

  let options = {
    id: layerSource,
    source: source,
    layerOptions: [layerOptions],
    map: map,
    mapClickEvent: mapClickEvent,
  };

  removeTileData({
    map: map,
    layerId: layerId,
    sourceId: layerSource,
  });

  addTileData(options);
};

const _getExternalLayersConfig = async () => {
  if (!layersConfig) {
    try {
      const url = ENDPOINT_EXTERNAL_LAYERS_CONFIG;
      const result = await httpGet({ url, noCache: true });
      const { data } = JSON.parse(result);

      if (data?.length) {
        layersConfig = data.filter((service) =>
          isFeatureUnlocked(`map-controls-external-layer-${service.id}`)
        );
      }

      return layersConfig;
    } catch (error) {
      console.error(
        "Issue getting external layers in mapControls.service.js: ",
        error
      );
      return null;
    }
  }
  return lodashCloneDeep(layersConfig);
};
